export const GetEnvironment = (): string => {
    return window.__CONFIG__.Environment;
};

export const IsProductionEnvironment = () => {
    return GetEnvironment() === "Production";
};

export const IsPublicEnvironment = () => {
    return GetEnvironment() === "Production" || GetEnvironment() === "Sandbox";
};
